import { render, staticRenderFns } from "./RoutineDetail.vue?vue&type=template&id=bab25486&scoped=true"
import script from "./RoutineDetail.vue?vue&type=script&lang=js"
export * from "./RoutineDetail.vue?vue&type=script&lang=js"
import style0 from "./RoutineDetail.vue?vue&type=style&index=0&id=bab25486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab25486",
  null
  
)

export default component.exports